import React from 'react';
import PropTypes from 'prop-types';
import Scrollspy from 'react-scrollspy';

import Navbar from '../Navbar';
import Footer from '../Footer';

import './fullprivacy.scss';

/* eslint-disable camelcase */
/* eslint-disable react/no-danger */

const PrivacyPage = ({ title, sections, html }) => (
  <React.Fragment>
    <Navbar loaded />
    <div className="privacy container">
      <div className="privacy__sidebar">
        <Scrollspy offset={-80} items={sections.map(section => section.section_object.id)} currentClassName="active">
          {sections.map(({ section_object }) => (
            <a key={section_object.id} href={`#${section_object.id}`}>{section_object.title}</a>
          ))}
        </Scrollspy>
      </div>
      <div className="privacy__content">
        <h1>{ title }</h1>
        <div className="privacy__content__html" dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </div>
    <Footer />
  </React.Fragment>
);
PrivacyPage.propTypes = {
  sections: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  title: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
};

export default PrivacyPage;



// WEBPACK FOOTER //
// ./src/components/FullPrivacy/index.jsx